import * as React from 'react';
import { CircleHelp, Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { RequirePermission } from '@klareospace/pharos-lib-front-utils';
import {
  ActionBar,
  ActionBarSpacer,
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@klareospace/pharos-lib-web-utils';

// ─── Types ────────────────────────────────────────────────────────────────────

interface HandlingUnitTypesActionBarProps {
  onAdd: () => void;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function HandlingUnitTypesActionBar({ onAdd }: HandlingUnitTypesActionBarProps): React.JSX.Element {
  const { t } = useTranslation('settings');

  return (
    <ActionBar>
      <ActionBarSpacer />
      <Popover>
        <PopoverTrigger asChild>
          <Button
            aria-label={t('handlingUnitTypes.actionBar.tooltip.title')}
            className="h-9 w-9 rounded-md"
            size="icon"
            variant="ghost"
          >
            <CircleHelp className="h-4 w-4" />
          </Button>
        </PopoverTrigger>
        <PopoverContent align="end" className="w-80">
          <div className="flex flex-col gap-2">
            <p className="text-sm font-semibold">{t('handlingUnitTypes.actionBar.tooltip.title')}</p>
            <p className="text-sm text-muted-foreground">{t('handlingUnitTypes.actionBar.tooltip.body')}</p>
          </div>
        </PopoverContent>
      </Popover>
      <RequirePermission permission="handling-unit-types:manage">
        <Button
          className="h-9 gap-1.5 rounded-md px-3 text-sm shadow-sm hover:shadow-md"
          onClick={onAdd}
          variant="default"
        >
          <Plus className="h-4 w-4" />
          {t('handlingUnitTypes.actionBar.add')}
        </Button>
      </RequirePermission>
    </ActionBar>
  );
}
